
import { getPageStructureFromTree } from "@/lib/singularity/page-structure/page-structure";
import { documentStore, singularityStore, uiStore } from "@/store/store";
import Vue from "vue";
import { Component } from "vue-property-decorator";
import PageStructureSectionNew from "./PageStructureSectionNew.vue";
import draggable from "vuedraggable";
import { PageSection } from "@/lib/singularity/page-structure/page-structure";
import Icon from "@/components/UI/Icon.vue";
import PageStructureHeader from "./PageStructureHeader.vue";

@Component({
  components: {
    PageStructureSectionNew,
    draggable,
    Icon,
    PageStructureHeader
  }
})
export default class PageStructure extends Vue {
  get structure() {
    return getPageStructureFromTree(documentStore.document.tree);
  }

  get pageTitle() {
    return documentStore.document.documentMeta.titleLabel;
  }

  handleChange(
    // https://github.com/SortableJS/Vue.Draggable#events
    event: {
      moved?: { newIndex: number; oldIndex: number; element: PageSection };
    }
  ) {
    if (event.moved) {
      const treeNodeIdToMove = event.moved.element.nodeId;
      const newIndex = event.moved.newIndex;
      documentStore.moveElement({
        draggedElementId: treeNodeIdToMove,
        droppedOnElementId: documentStore.document.tree.root.id,
        index: newIndex
      });

      uiStore.activateElement(treeNodeIdToMove);
    }
  }

  addSection() {
    singularityStore.setSectionAddOrSwapPanelState({
      mode: "add",
      sectionIdToAddAfterOrSwap: this.structure.length
        ? this.structure[this.structure.length - 1].nodeId
        : null
    });
    singularityStore.setSingularityLeftPanel("section_add_or_swap");
  }
}
